(ns common.schema.entities.oppo.time-fields
  "The time fields of a deal that the search index holds.

   An age in days depends on the day of today, so the index cannot hold it. The
   index holds the start of the age instead (`active-since`, `on-hold-since`),
   and a query or a view computes the days from it. A throughput does not depend
   on today, so the index holds its value.")

(def ^:private millis-per-week
  (* 7 24 60 60 1000))

(defn- whole-units
  "The number of whole `unit-millis` in `millis`, rounded up as the old grid does."
  [millis unit-millis]
  (long (Math/ceil (/ (double millis) unit-millis))))

(defn active-since
  "The time from which a deal is active: its creation time, for a deal with the
   status ok. Nil for any other status."
  [{:keys [entity-data]}]
  (when (= :oppo.status/ok (:oppo/status entity-data))
    (:common/created-on entity-data)))

(defn on-hold-since
  "The time at which a deal on hold was put on hold. Nil for any other status."
  [{:keys [entity-data]}]
  (when (= :oppo.status/on-hold (:oppo/status entity-data))
    (:oppo/put-on-hold-on entity-data)))

(defn- weeks-between
  [from to]
  (when (and (inst? from) (inst? to))
    (whole-units (- (inst-ms to) (inst-ms from)) millis-per-week)))

(defn throughput-in-weeks-passed
  "The weeks from the creation of a passed deal to its pass. Nil for any other status."
  [{:keys [entity-data]}]
  (when (= :oppo.status/passed (:oppo/status entity-data))
    (weeks-between (:common/created-on entity-data) (:oppo/passed-on entity-data))))

(defn throughput-in-weeks-invested
  "The weeks from the creation of an invested deal to its move to the portfolio.
   Nil for any other status."
  [{:keys [entity-data]}]
  (when (= :oppo.status/portfolio (:oppo/status entity-data))
    (weeks-between (:common/created-on entity-data) (:oppo/moved-to-portfolio-on entity-data))))
